module.exports = __webpack_public_path__ + "assets/img/DB-Results-2-Service-Page-w720.6e287f91.jpg";